import {
  IGetSubscriptionsDTO,
  SubscriptionsEndpoints,
  IGetSubscriptionsResponse,
  IExportSubscriptionsResponse,
} from '@/models/subscriptions.model';
import { ApiResponse, httpClient } from '@/utils';

class SubscriptionsAPI {
  static getSubscriptions(data: IGetSubscriptionsDTO): ApiResponse<IGetSubscriptionsResponse> {
    return httpClient.get<IGetSubscriptionsResponse>(SubscriptionsEndpoints.SUBSCRIPTIONS, { params: data });
  }

  static exportSubscriptions(): ApiResponse<IExportSubscriptionsResponse> {
    return httpClient.get<IExportSubscriptionsResponse>(SubscriptionsEndpoints.EXPORT_SUBSCRIPTIONS);
  }

  static deleteSubscription(id: string): ApiResponse<void> {
    return httpClient.delete<void>(`${SubscriptionsEndpoints.SUBSCRIPTIONS}/${id}`);
  }
}

export default SubscriptionsAPI;
